import React, { lazy, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  MainContainer,
  RecogntionTopCard,
  FeaturedCard
} from "../Recognition/CompanyAnalytics/styles";
import { ImageUrl } from "../../utils/constants";
import { commaSeperator } from "../../utils/methods";
import {TopChallengesWrapper} from "../CompanyEvents/styles";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import { Table } from '../common/commonStyles';
import {Heading, ScrollableContainer, ShowMore } from '../RecogntionAdmin/styles'
import MonthlyBarChart from "../common/Manager/MonthlyChart/MonthlyBarChart";
import {NoInitiativeCard, CommonButton, HoverBackground, HdmTopCard} from './styles'
import {LaunchInitiatives, WellnessInitiatives, RecognitionEyeIcon, UpcomingInitiatives, DownArrow, DeleteIconBranding} from '../../utils/icons'
import SkeletonLoder from "../common/skeletonLoder";
import { NameInitials } from "../Manager/styles";
import { getInitials, fetchApi } from "../../utils/methods";
import DetailPopup from './initiativesInfo';
import DeletePopup from '../DeletePostPopup/deletePopupBranding'
import { DeleteCompanyInitiative } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";

const CompanyAnalytics = ({history, getSnapShotValue, getDeptAndLocData, getBestPerformerMonth, getBestPerformerQuarter, getBestPerformerMonthUsers, updatePageMonth, bestPerformerPageMonth, updatePageQuarter, getBestPerformerQuarterUsers,  bestPerformerPageQuarter, manageHealthTabs, companyId, showHideCustomize, getFeatured, getActive, getUpcoming, selectedYear, fetchUpcomingInitiatives}) => {
  const [showEmployeeQuarter, setShowEmployeeQuarter] = useState(false);
  const [showEmployeeMonth, setShowEmployeeMonth] = useState(false);
  const [onHover, setHover] = useState(null);
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [detailInitiative, setDetailInitiative] = useState({});
  const [showAllActive, setShowAllActive] = useState(false);
  const [showAllUpcoming, setShowAllUpcoming] = useState(false);
  const [deleteInitiative, setDeleteInitiative] = useState(false);
  const [deleteInitiativeData, setDeleteInitiativeData] = useState({});

  const hideDeleteInitiative = () => {
    setDeleteInitiative(false);
  }

  const showDeleteInitiativePopup = (data) =>{
    setDeleteInitiative(true)
    setDeleteInitiativeData(data)
  }

  const deleteInitiativeApiCall = async () => {
    try {
      const startDate = deleteInitiativeData?.start_date;
      const endDate = deleteInitiativeData?.end_date;
      const postData = {
        company_id: companyId,
        initiative_id: deleteInitiativeData.id,
        start_date: startDate,
        end_date: endDate,
      }; 
      const res = await fetchApi(
        DeleteCompanyInitiative+"/"+companyId,
        "POST",
        postData,
        {},
      );
      if (res.message) {
        toast.error(res.message);
      }
      fetchUpcomingInitiatives()
      setDeleteInitiative(false)
      setDeleteInitiativeData()
      toast.success("Initiative deleted successfully");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const currentYear = new Date().getFullYear();
  const hideCardsForPreviousYear= selectedYear==currentYear

  const showInitiativeInfo = (value) => {
    setShowDetailPopup(true)
    setDetailInitiative(value)
  }

  const hideInitiativeInfo = () => {
    setShowDetailPopup(false)
  }

  const topDepartment = () => {
    const department=getDeptAndLocData?.top_three_departments
    const dataArray = [
      { name: department[0]?.name, color: '#FFF', value: department[0]?.total_participation, width: 204, background: '#BE7D9C' },
      { name: department[1]?.name, color: '#FFF', value: department[1]?.total_participation, width: 160, background: '#92A4DA' },
      { name: department[2]?.name, color: '#FFF', value: department[2]?.total_participation, width: 96, background: '#75B084' },
    ];
    return (
      getDeptAndLocData?.top_three_departments?.length>0&&<TopDataGraph data={dataArray} heading={'Top Performing Departments'} total={getDeptAndLocData?.total_top_departments} totalSubText='Total Initiatives' />
    );
  };

  const topLocation = () => {
    const location=getDeptAndLocData?.top_three_locations
    const dataArray = [
      { name: location[0]?.name, color: '#FFF', value: location[0]?.total_participation, width: 204, background: '#B1AA56' },
      { name: location[1]?.name, color: '#FFF', value: location[1]?.total_participation, width: 160, background: '#DA92C8' },
      { name: location[2]?.name, color: '#FFF', value: location[2]?.total_participation, width: 96, background: '#DA6C74' },
    ];
    return (
      getDeptAndLocData?.top_three_locations?.length>0&&<TopDataGraph data={dataArray} heading={'Top Performing Locations'} total={getDeptAndLocData?.total_top_locations} totalSubText='Total Initiatives' />
    );
  };

  const redirectToCompanyInitiative = (obj) => {
    history.push({pathname: "/company/company-initiative", state: {id: obj?.id, initiative_name: obj?.initiative_name,initiativeDetails:obj}});
  };

  const showRecognitionDetails = () => {
    const EngagementEmployeeData = [
      {
        title: "Total Initiatives Launched",
        value: "1",
        img: "images/AdminReports/total.svg",
        text: "posted",
        color: "rgba(133, 192, 234, 1)",
        total: (getSnapShotValue?.top_4_cards?.total_initiatives_launched),
        imageBackground: "#BE7D9C",
        info: "",
        // average:`Avg ${getSnapShotValue?.top_4_cards?.user_initiatives_launched_percentage} initiative launched per users`,
        average:'',
        is_launch:1,
        showHover: false
      },
      {
        title: "Completed Initiatives",
        titleNew: "",
        value: "2",
        img: "images/AdminReports/completed.svg",
        text: "received recognition",
        color: "rgba(220, 148, 181, 1)",
        total: (getSnapShotValue?.top_4_cards?.completed_initiatives),
        average: getSnapShotValue?.top_4_cards?.user_initiative_taken_percentage+ "% of users have completed an initiative",
        imageBackground: "#75B084",
        info: "",
        is_launch:1,
        id:null,
        showHover: false
      },
      {
        title: "WBA Participation",
        value: "3",
        img: getSnapShotValue?.default_initiative_details&& getSnapShotValue?.default_initiative_details[0]?.initiative_white_icon,
        text: "gave recognition",
        color: "rgba(118, 171, 120, 1)",
        total: (getSnapShotValue?.top_4_cards?.total_wba_participation),
        average:`${getSnapShotValue?.top_4_cards?.user_WBA_taken_percentage}% of users participated`,
        imageBackground: getSnapShotValue?.default_initiative_details&& getSnapShotValue?.default_initiative_details[0]?.color,
        info: "",
        is_launch:getSnapShotValue?.top_4_cards?.WBA_status,
        id: 1,
        showHover: true,
        isLaunch:getSnapShotValue?.top_4_cards?.WBA_status
      },
      {
        title: "Biometrics Participation",
        titleNew: "Value",
        value: "4",
        img: getSnapShotValue?.default_initiative_details && getSnapShotValue?.default_initiative_details[1]?.initiative_white_icon,
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: (getSnapShotValue?.top_4_cards?.total_biometrics_participation),
        average:`${getSnapShotValue?.top_4_cards?.user_biometrics_taken_percentage}% of users participated`,
        imageBackground: getSnapShotValue?.default_initiative_details&& getSnapShotValue?.default_initiative_details[1]?.color,
        info: "",
        is_launch:getSnapShotValue?.top_4_cards?.biometrics_status,
        id:2,
        showHover: true,
        isLaunch:getSnapShotValue?.top_4_cards?.biometrics_status
      },
    ];
    return (
      EngagementEmployeeData?.map((details, index) => (
        getSnapShotValue?.top_4_cards?
          <RecogntionTopCard padding={onHover===details?.id&&details?.showHover&&details?.isLaunch?"0px":"12px"} display key={index} background={details.imageBackground} onMouseEnter={details?.isLaunch?() => setHover(details?.id):null} onMouseLeave={() => setHover(-1)}>
            <div className="image">
              <img src={ImageUrl +'/'+ details.img} />
            </div>
            <div className="title">{details.title}</div>
            {details?.is_launch?<>
              <div className="value">{commaSeperator(details?.total)}</div>
              <div className="percent-user">{details.average}</div>
            </>:
              <div className="button-launch">
                <CommonButton width="200px !important" style={{height:"40px"}} onClick={index===2?()=>redirectToCompanyInitiative(getSnapShotValue?.default_initiative_details[0]): ()=>redirectToCompanyInitiative(getSnapShotValue?.default_initiative_details[1])}>{index===2?"Launch WBA":"Launch Biometric"}</CommonButton>
              </div>}
            {onHover===details?.id&&details?.showHover&&<HoverBackground >
              <div className='view-button'
                // onClick={() => showInitiativeInfo(details)}
                onClick={index===2?()=>showInitiativeInfo(getSnapShotValue?.default_initiative_details[0]): ()=>showInitiativeInfo(getSnapShotValue?.default_initiative_details[1])}
                onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
                onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
                <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
              </div>
            </HoverBackground>}
          </RecogntionTopCard>:<SkeletonLoder width="290px" height="200px" key={index}/>
      )));
  };

  const featuerdInitiatives = () => {
    const featureCards =getFeatured;
    return featureCards?.map((details, index) => (
      <FeaturedCard display key={index} width background={details.color} onMouseEnter={details?.is_launch? () => setHover(details?.id):null} onMouseLeave={() => setHover(-1)}>
        <div className="wrapFeaturted">
          <div className="image">
            <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
          </div>
          <div className="title">{details.initiative_name}</div>
          {details?.is_launch?<>
            <div className="value">{commaSeperator(details?.total_participation)}</div>
            <div className="percent-user">{details?.user_initiative_taken_percentage}% of users have completed the initiative</div>
          </>:
            hideCardsForPreviousYear&&<div className="button-launch" >
              <CommonButton width="200px" onClick={()=>redirectToCompanyInitiative(details)}><div className="icon"><LaunchInitiatives/></div>Launch Initiative</CommonButton>
            </div>}
        </div>
        {onHover===details?.id&&<HoverBackground width>
          <div className='view-button'
            onClick={() => showInitiativeInfo(details)}
            onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
            onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
            <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
          </div>
        </HoverBackground>}  
      </FeaturedCard >
    ));
  };

  const activeInitiatives = () => {
    const activeCards = showAllActive?getActive:getActive?.slice(0,4);
    return activeCards?.map((details, index) => (
      <>
        <HdmTopCard key={index} background={details.color} onMouseEnter={() => setHover(details?.id)} onMouseLeave={() => setHover(-1)}>
          <div className="div-wrap">
            <div className="image">
              <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
            </div>
            <div className="title">{details.initiative_name}</div>
            <div className="value">{commaSeperator(details?.total_participation)}</div>
            <div className="percent-user">{details?.user_initiative_taken_percentage}% of users have completed the initiative</div>
          </div>
          {onHover===details?.id&&<HoverBackground>
            <div className='view-button'
              onClick={() => showInitiativeInfo(details)}
              onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
              onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
              <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
            </div>
          </HoverBackground>}
        </HdmTopCard>
      </>
    ));
  };

  const upcomingInitiatives = () => {
    const upcomingCards = showAllUpcoming?getUpcoming:getUpcoming?.slice(0,4);
    return upcomingCards?.map((details, index) => (
      <>
        <HdmTopCard key={index} background={details?.color} isCardHeight={"196px"}>
          <div className="div-wrap">
            <div className="image">
              <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
            </div>
            <div className="title">{details.initiative_name}</div>
            <div className="percent-user" style={{marginTop:"4px"}}>{Math.ceil((Number(new Date(details?.start_date) - new Date())/ (1000 * 60 * 60 * 24)))} days to go</div>
            <div className="deleteButton"><span className="icon" onClick={()=>showDeleteInitiativePopup(details)}>{DeleteIconBranding()}</span></div>
          </div>
        </HdmTopCard>
      </>
    ));
  };

  const toggleShowEliteRecognition = () => {
    setShowEmployeeQuarter(!showEmployeeQuarter);
  };

  const toggleShowTopRecognition = () => {
    setShowEmployeeMonth(!showEmployeeMonth)
  };

  const onScrollMonth = (e) => {
    const diff=Math.round(e.target.scrollHeight - e.target.scrollTop) - Math.round(e.target.clientHeight)
    const isBottom = Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1)||Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight);
    if (
      (isBottom||diff===1) && getBestPerformerMonthUsers?.length < getBestPerformerMonth?.total
    ) {
      updatePageMonth(bestPerformerPageMonth + 1); // Increment page number correctly
    }
  };

  const onScrollQuarter = (e) => {
    const diff=Math.round(e.target.scrollHeight - e.target.scrollTop) - Math.round(e.target.clientHeight)
    const isBottom = Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1)||Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight);
    if (
      (isBottom||diff===1) && getBestPerformerQuarterUsers?.length < getBestPerformerQuarter?.total
    ) {
      updatePageQuarter(bestPerformerPageQuarter + 1); // Increment page number correctly
    }
  };

  const bestPerformer = (value)=>{
    const displayedEmployeeMonthly = showEmployeeMonth ?  getBestPerformerMonthUsers : getBestPerformerMonthUsers?.slice(0,5) ;
    const displayedEmployeeQuarterly = showEmployeeQuarter ? getBestPerformerQuarterUsers : getBestPerformerQuarterUsers?.slice(0, 5);
    return(
      <>
        <div className='top-performing' style={{display:"block"}} >
          <Table padding="8px 0" insight>
            <div className="heading">{getBestPerformerMonth?.month_name} | Monthly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Initiatives</div>
              </div>
            )}
            <ScrollableContainer
              height={showEmployeeMonth ? "380px" : "330px"}
              showAllRows={showEmployeeMonth}
              onScroll={(e)=>onScrollMonth(e)}
            >
              {displayedEmployeeMonthly?.length>0?   displayedEmployeeMonthly?.map((data, index) => (
                <div className="item" key={index}>
                  {data.profile_image !== "profile-Image/default.png" ?<div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data?.user_name} />
                  </div>:
                    <NameInitials id="name-initials" margin="0 8px 0 0">
                      {getInitials(data?.user_name)}
                    </NameInitials> 
                  }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.participation_count}</div>
                </div>
              )):<div className="no-data">No Data Found</div>}
            </ScrollableContainer>
            {getBestPerformerMonth?.total > 5 && !showEmployeeMonth && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>

        </div>
        <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">{getBestPerformerQuarter?.quarter_name} | Quarterly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Initiatives</div>
              </div>
            )}
            <ScrollableContainer
              height={showEmployeeQuarter ? "380px" : "330px"}
              showAllRows={showEmployeeQuarter}
              onScroll={(e)=>onScrollQuarter(e)}
            >
              {displayedEmployeeQuarterly?.length>0? displayedEmployeeQuarterly?.map((data, index) => (
                <div className="item" key={index}>
                  {data.profile_image !== "profile-Image/default.png" ?<div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data?.user_name} />
                  </div>:
                    <NameInitials id="name-initials" margin="0 8px 0 0">
                      {getInitials(data?.user_name)}
                    </NameInitials> 
                  }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.participation_count}</div>
                </div>
              )):<div className="no-data">No Data Found</div>}
            </ScrollableContainer>
            {getBestPerformerQuarter?.total > 5 && !showEmployeeQuarter && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>
        </div>
      </>
    )
  }

  return (
    <>
      <MainContainer margin>
        <TopChallengesWrapper margin="0 0 0px 0">
          {showRecognitionDetails()}
        </TopChallengesWrapper>
        {getSnapShotValue?.monthly_breakdown&&<div style={{marginTop:"20px"}}><MonthlyBarChart heading="Monthly Breakdown" totalText="Initiative Participation" dataGraph={getSnapShotValue?.monthly_breakdown} totalPercentage={getSnapShotValue?.monthly_growth} total={getSnapShotValue?.Initiative_participation} barColor={"#CE98B3"} barColorActive={"#A65C7C"} /></div>}
        {getFeatured?.length>0?null:showHideCustomize&&<NoInitiativeCard>
          <div className="image">
            <img src={ImageUrl+"/images/AdminReports/demo.svg"}/>
          </div>
          <div className="details">
            <div className="title">Customize your dashboard.</div>
            <div className="subtext">Set up your preferences to ensure your dashboard is tailored to meet your specific health data management needs,<br/> providing you with a seamless and personalized experience.</div>
            <div className="button">
              <CommonButton onClick={()=>history.push('/company/health/customize')}>Let’s Get Started</CommonButton>
            </div>
          </div>
        </NoInitiativeCard>}



        
        {getFeatured?.length>0&&<>
          <Heading>
            <div className='icon'>
              <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
            </div>
            Featured Initiatives
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px">
            {featuerdInitiatives()}
          </TopChallengesWrapper>
        </>}
        {getActive?.length>0&&hideCardsForPreviousYear&&<>
          <Heading>
            <div className='icon'>
              <WellnessInitiatives/>
            </div>
            Active Initiatives
            {getActive.length>4&&!showAllActive&&<div className="dropdown">
              <ShowMore onClick={()=>setShowAllActive(true)} >
                <div className="show-more">Show more</div> <div className="icon"><DownArrow/></div>
              </ShowMore >
            </div>}
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px" >
            {activeInitiatives()}
            {getActive?.length<4 && showHideCustomize&&<div className="button">
              <CommonButton id="hdm-launch-initiative" width="200px" padding="10px 16px" onClick={()=>manageHealthTabs('library')}><div className="icon"><LaunchInitiatives/></div>Launch Initiative</CommonButton>
            </div>}
          </TopChallengesWrapper>
        </>}
        {getUpcoming?.length>0&&hideCardsForPreviousYear&&<>
          <Heading>
            <div className='icon'>
              <UpcomingInitiatives/>
            </div>
            Upcoming Initiatives
            {getUpcoming.length>4&&!showAllUpcoming&&<div className="dropdown">
              <ShowMore onClick={()=>setShowAllUpcoming(true)} >
                <div className="show-more">Show more</div> <div className="icon"><DownArrow/></div>
              </ShowMore >
            </div>}
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px" >
            {upcomingInitiatives()}
          </TopChallengesWrapper>
        </>}
        <Heading>
          <div className='icon'>
            <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
          </div>
          Best Performers
        </Heading>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          {bestPerformer()}
        </div>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          {getDeptAndLocData?.total_top_departments>0&&<div className='top-performing'>{topDepartment()}</div>}
          {getDeptAndLocData?.total_top_locations>0&&<div className='top-performing'>{topLocation()}</div>}
        </div>
        {showDetailPopup && <DetailPopup showModal={showDetailPopup} detailInitiative={detailInitiative} onClose={hideInitiativeInfo} companyId={companyId}/>}
        {deleteInitiative&&<DeletePopup
          showModal={deleteInitiative}
          onClose={hideDeleteInitiative}
          deleteConsumer={deleteInitiativeApiCall}
          type="initiative"
        />}
      </MainContainer>
    </>
  );
};

CompanyAnalytics.propTypes = {
  selectedYearInfo: PropTypes.number,
  companyId: PropTypes.number,
  history: PropTypes.object,
  getSnapShotValue: PropTypes.object,
  getDeptAndLocData: PropTypes.object,
  getBestPerformerMonth: PropTypes.object,
  getBestPerformerQuarter: PropTypes.object,
  updatePageMonth: PropTypes.func,
  updatePageQuarter: PropTypes.func,
  bestPerformerPageQuarter: PropTypes.number,
  bestPerformerPageMonth: PropTypes.number,
  getBestPerformerMonthUsers: PropTypes.array,
  getBestPerformerQuarterUsers: PropTypes.array,
  manageHealthTabs: PropTypes.func,
  showHideCustomize: PropTypes.bool,
  getUpcoming: PropTypes.array,
  getActive: PropTypes.array,
  getFeatured: PropTypes.array,
  selectedYear: PropTypes.number,
  fetchUpcomingInitiatives: PropTypes.func
};

const mapStateToProps = (state) => ({
  selectedYearInfo: state.companyDashboard.selectedYearInfo
});

export default connect(mapStateToProps, null)(CompanyAnalytics);